import axios from '@/lib/API/client'

export const UPLOAD_SENSOR_TYPE_MOVEPRO = 'movepro'
export const UPLOAD_SENSOR_TYPE_HEARTRATE = 'heartrate'

export const normalizeUploadLookupFilename = (filename) => {
    const normalized = String(filename || '').trim()
    if (!normalized) return ''

    const lastDotIndex = normalized.lastIndexOf('.')
    if (lastDotIndex <= 0) {
        return normalized
    }

    return normalized.slice(0, lastDotIndex)
}

const normalizeUploadLookupSensorType = (sensorType) => String(sensorType || '').trim()

const normalizeUploadLookupUploads = (uploads = []) =>
    (Array.isArray(uploads) ? uploads : []).map((upload) => ({
        upload_id: Number(upload?.upload_id) || null,
        session_id: Number(upload?.session_id) || null,
        session_name: typeof upload?.session_name === 'string' ? upload.session_name : '',
        discipline: upload?.discipline === undefined || upload?.discipline === null ? null : String(upload.discipline),
    }))

const buildUploadLookupErrorResult = (fallback = {}, error = 'upload lookup item error') => ({
    filename: fallback.filename || '',
    sensor_type: fallback.sensor_type || '',
    exists: null,
    count: 0,
    uploads: [],
    error,
    status: 'error',
})

const normalizeUploadLookupResult = (item = {}, fallback = {}) => {
    const filename = typeof item?.filename === 'string' ? normalizeUploadLookupFilename(item.filename) : ''
    const sensorType = normalizeUploadLookupSensorType(item?.sensor_type)
    const fallbackFilename = fallback.filename || ''
    const fallbackSensorType = fallback.sensor_type || ''

    if (filename !== fallbackFilename || sensorType !== fallbackSensorType) {
        return buildUploadLookupErrorResult(fallback, 'upload lookup response mismatch')
    }

    const normalized = {
        filename,
        sensor_type: sensorType,
        exists: typeof item?.exists === 'boolean' ? item.exists : null,
        count: Number(item?.count) || 0,
        uploads: normalizeUploadLookupUploads(item?.uploads),
        error: typeof item?.error === 'string' && item.error.trim() ? item.error : null,
        status: 'success',
    }

    if (normalized.error) {
        return buildUploadLookupErrorResult(fallback, normalized.error)
    }

    return normalized
}

export const lookupUploads = async (items = [], { timeout = 5000 } = {}) => {
    const payload = (Array.isArray(items) ? items : [])
        .map((item) => ({
            filename: normalizeUploadLookupFilename(item?.filename),
            sensor_type: normalizeUploadLookupSensorType(item?.sensor_type),
        }))
        .filter((item) => item.filename && item.sensor_type)

    if (payload.length === 0) {
        return []
    }

    const response = await axios.post('uploads/lookup', payload, { timeout })
    const data = Array.isArray(response?.data) ? response.data : []

    return payload.map((item, index) => normalizeUploadLookupResult(data[index], item))
}

export const lookupUpload = async (item, options = {}) => {
    const [result = null] = await lookupUploads([item], options)
    return result
}
